/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { HarvestCustomerDefaultsDto } from '../../models/harvest-customer-defaults-dto';

export interface GetDefaults$Params {
  customerId?: number;
}

export function getDefaults(http: HttpClient, rootUrl: string, params?: GetDefaults$Params, context?: HttpContext): Observable<StrictHttpResponse<HarvestCustomerDefaultsDto>> {
  const rb = new RequestBuilder(rootUrl, getDefaults.PATH, 'get');
  if (params) {
    rb.query('customerId', params.customerId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<HarvestCustomerDefaultsDto>;
    })
  );
}

getDefaults.PATH = '/api/harvests/defaults';
